import { createCaseDraftPlaceholderIndices } from '@/workflow-builder/_pure/model/machineDraft';
import type { Draft } from '@/workflow-builder/_contract/draft';

type LoopDraft = Extract<Draft, { draftKind: 'while' | 'for' }>;
type BranchDraft = Extract<Draft, { draftKind: 'branch' }>;

export function isLoopCaseCleared(draft: LoopDraft): boolean {
    return draft.caseDraft.what === null && draft.caseDraft.when === null;
}

export function clearLoopCaseWhatAndWhen(draft: LoopDraft): LoopDraft {
    return {
        ...draft,
        caseDraft: {
            ...draft.caseDraft,
            what: null,
            when: null,
            loopFeedbackBindingSpec: null,
        },
    };
}

export function clearLoopCaseWhen(draft: LoopDraft): LoopDraft {
    return {
        ...draft,
        caseDraft: {
            ...draft.caseDraft,
            when: null,
        },
    };
}

export function clearBranchCaseWhen(draft: BranchDraft, caseIndex: number): BranchDraft | null {
    const nextCases = [...draft.caseSetDraft.cases];
    const targetCase = nextCases[caseIndex];
    if (!targetCase) {
        return null;
    }

    const placeholderIndex = targetCase.placeholderIndexWhen ?? createCaseDraftPlaceholderIndices({
        draftKind: 'branch',
        caseIndex,
    }).placeholderIndexWhen;

    nextCases[caseIndex] = {
        ...targetCase,
        when: null,
        placeholderIndexWhen: placeholderIndex,
    };

    return {
        ...draft,
        caseSetDraft: {
            ...draft.caseSetDraft,
            cases: nextCases as typeof draft.caseSetDraft.cases,
        },
    };
}

export function clearBranchCaseWhat(draft: BranchDraft, caseIndex: number): BranchDraft | null {
    const nextCases = [...draft.caseSetDraft.cases];
    const targetCase = nextCases[caseIndex];
    if (!targetCase) {
        return null;
    }

    const placeholderIndex = targetCase.placeholderIndexWhat ?? createCaseDraftPlaceholderIndices({
        draftKind: 'branch',
        caseIndex,
    }).placeholderIndexWhat;

    nextCases[caseIndex] = {
        ...targetCase,
        what: null,
        placeholderIndexWhat: placeholderIndex,
    };

    return {
        ...draft,
        caseSetDraft: {
            ...draft.caseSetDraft,
            cases: nextCases as typeof draft.caseSetDraft.cases,
        },
    };
}

export function clearBranchDefaultWhen(draft: BranchDraft): BranchDraft {
    return {
        ...draft,
        caseSetDraft: {
            ...draft.caseSetDraft,
            defaultCase: null,
        },
    };
}

export function clearBranchDefaultWhat(draft: BranchDraft): BranchDraft | null {
    if (!draft.caseSetDraft.defaultCase) {
        return null;
    }

    return {
        ...draft,
        caseSetDraft: {
            ...draft.caseSetDraft,
            defaultCase: null,
        },
    };
}
